import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const MemberContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MemberProvider = ({ children }) => {
    const [member, setMember] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('voidwolves_member_token'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (token) {
            verifyToken();
        } else {
            setLoading(false);
        }
    }, [token]);

    const verifyToken = async () => {
        try {
            const response = await axios.get(`${API}/member/auth/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMember(response.data);
        } catch (error) {
            console.error('Member token verification failed:', error);
            logout();
        } finally {
            setLoading(false);
        }
    };

    const login = async (email, password) => {
        const response = await axios.post(`${API}/member/auth/login`, { email, password });
        const { access_token } = response.data;
        localStorage.setItem('voidwolves_member_token', access_token);
        setToken(access_token);
        // Immediately verify and set member data
        const meResponse = await axios.get(`${API}/member/auth/me`, {
            headers: { Authorization: `Bearer ${access_token}` }
        });
        setMember(meResponse.data);
        return response.data;
    };

    const register = async (callsign, email, password, discord_id) => {
        const response = await axios.post(`${API}/member/auth/register`, { 
            callsign, 
            email, 
            password, 
            discord_id 
        });
        return response.data;
    };

    const logout = () => {
        localStorage.removeItem('voidwolves_member_token');
        setToken(null);
        setMember(null);
    };

    const getAuthHeaders = () => ({
        headers: { Authorization: `Bearer ${token}` }
    });

    return (
        <MemberContext.Provider value={{ member, token, loading, login, register, logout, getAuthHeaders }}>
            {children}
        </MemberContext.Provider>
    );
};

export const useMember = () => {
    const context = useContext(MemberContext);
    if (!context) {
        throw new Error('useMember must be used within a MemberProvider');
    }
    return context;
};
